module.exports = __webpack_public_path__ + "media/images/email/logo1-73dca49be327f7efef77fc80cbc35714.png";